import React, { useContext } from "react";
import "./App.css";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Routes, Route, Navigate } from "react-router-dom";

import Main from "./pages/newPages/Main";
import Objects from "./pages/newPages/Objects";
import Slider from "./pages/newPages/Slider";
import Comment from "./pages/newPages/Comment";
import Orders from "./pages/newPages/Orders";

import Mains from "./pages/Main";
import About from "./pages/About";
import Layout from "./components/Layout/Layout";
import LoginPage from "./pages/LoginPage";
import StatisticsPage from "./pages/StatisticsPage";
// import Orders from "./pages/Orders";
import List from "./pages/List";
import Admin from "./pages/newPages/Admin";
import Yandex from "./pages/newPages/Yandex";
import Error from "./pages/newPages/Error";

import { MainContext, MainProvider } from "./context/MainContext";

const PrivateRoute = ({ element }) => {
  const { isLoadUserId } = useContext(MainContext);
  return isLoadUserId ? element : <Navigate to="/yandex" />;
};

function setAppHeight() {
  const appHeight = window.innerHeight;
  document.documentElement.style.setProperty("--app-height", `${appHeight}px`);
}

window.addEventListener("resize", setAppHeight);
window.addEventListener("orientationchange", setAppHeight);
setAppHeight();

function App() {
  return (
    <MainProvider>
      <Routes>
        <Route path="/yandex" element={<Yandex />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/error" element={<Error />} />
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<PrivateRoute element={<Main />} />} index />
          <Route path="map" element={<PrivateRoute element={<Mains />} />} />
          <Route path="about" element={<PrivateRoute element={<About />} />} />
          <Route path="statistics" element={<PrivateRoute element={<StatisticsPage />} />} />
          <Route path="orders" element={<PrivateRoute element={<Orders />} />} />
          <Route path="list" element={<PrivateRoute element={<List />} />} />

          <Route path="objects" element={<PrivateRoute element={<Objects />} />} />
          <Route path="slider" element={<PrivateRoute element={<Slider />} />} />
          <Route path="comment" element={<PrivateRoute element={<Comment />} />} />

          <Route path="admin" element={<PrivateRoute element={<Admin />} />} />
        </Route>
      </Routes>
      <ToastContainer />
    </MainProvider>
  );
}

export default App;
